import { FC } from 'react';
import { useSnapshot } from 'valtio';
import AuditLogsContainer from '../../../audit-logs/containers/AuditLogsContainer';
import {
  useIsUserReadOnlyRole,
  useUserAdminRole,
} from '../../../members/api/user-roles-api';
import ScanStore from '../../../new-scan/store/scan-store';
import FixedPage from '../FixedPage';

const AuditLogsPage: FC = () => {
  const isAdminUser = useUserAdminRole();
  const isReadOnlyUser = useIsUserReadOnlyRole();
  const { isDemoEnabled } = useSnapshot(ScanStore);

  return (
    <FixedPage>
      <AuditLogsContainer
        isReadOnlyUser={isReadOnlyUser || isDemoEnabled}
        isUserAdminRole={isAdminUser}
      />
    </FixedPage>
  );
};

export default AuditLogsPage;
